import { render, staticRenderFns } from "./merchant-class.vue?vue&type=template&id=7126d15a&scoped=true"
import script from "./merchant-class.vue?vue&type=script&lang=js"
export * from "./merchant-class.vue?vue&type=script&lang=js"
import style0 from "./merchant-class.vue?vue&type=style&index=0&id=7126d15a&prod&scoped=true&lang=css"
import style1 from "./merchant-class.vue?vue&type=style&index=1&id=7126d15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126d15a",
  null
  
)

export default component.exports